import React, { lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import { PAGE_ROUTES } from '../constants/pageRoutes';
import Login from '../pages/presentation/auth/Login';
import ForgotPassword from '../pages/presentation/auth/ForgotPassword';
import ResetPassword from '../pages/presentation/auth/ResetPassword';

const DashboardPage = lazy(() => import('../pages/presentation/dashboard/DashboardPage'));
const ProfilePage = lazy(() => import('../pages/presentation/profile/ProfilePage'));
const GeneralSettingsPage = lazy(() => import('../pages/presentation/setting/GeneralSettingsPage'));
const UserListPage = lazy(() => import('../pages/presentation/user/UserListPage'));
const UserAddPage = lazy(() => import('../pages/presentation/user/UserAddPage'));
const UserViewPage = lazy(() => import('../pages/presentation/user/UserViewPage'));
const UserEditPage = lazy(() => import('../pages/presentation/user/UserEditPage'));
const LoginHistoryPage = lazy(() => import('../pages/presentation/loginHistory/LoginHistoryPage'));
const RoleListPage = lazy(() => import('../pages/presentation/role/RoleListPage'));
const RoleAddPage = lazy(() => import('../pages/presentation/role/RoleAddPage'));
const RoleViewPage = lazy(() => import('../pages/presentation/role/RoleViewPage'));
const RoleEditPage = lazy(() => import('../pages/presentation/role/RoleEditPage'));
const ItemListPage = lazy(() => import('../pages/presentation/master/item/ItemListPage'));
const ItemTypeListPage = lazy(
	() => import('../pages/presentation/master/itemType/ItemTypeListPage'),
);
const SizeListPage = lazy(() => import('../pages/presentation/master/size/SizeListPage'));
const ColourListPage = lazy(() => import('../pages/presentation/master/colour/ColourListPage'));
const ProcessListPage = lazy(() => import('../pages/presentation/master/process/ProcessListPage'));
const FabricListPage = lazy(() => import('../pages/presentation/master/fabric/FabricListPage'));
const FabricTypeListPage = lazy(
	() => import('../pages/presentation/master/fabricType/FabricTypeListPage'),
);
const FabricStageListPage = lazy(
	() => import('../pages/presentation/master/fabricStage/FabricStageListPage'),
);
const PartyListPage = lazy(() => import('../pages/presentation/master/party/PartyListPage'));
const CuttingComponentListPage = lazy(
	() => import('../pages/presentation/master/cuttingComponent/CuttingComponentListPage'),
);
const LabourListPage = lazy(() => import('../pages/presentation/master/labour/LabourListPage'));
const FabricInwardListPage = lazy(
	() => import('../pages/presentation/production/fabricInward/FabricInwardListPage'),
);
const FabricInwardViewPage = lazy(
	() => import('../pages/presentation/production/fabricInward/FabricInwardViewPage'),
);
const FabricStockListPage = lazy(
	() => import('../pages/presentation/production/fabricStock/FabricStockListPage'),
);
const CuttingStockListPage = lazy(
	() => import('../pages/presentation/production/cuttingStock/CuttingStockListPage'),
);
const CuttingListPage = lazy(
	() => import('../pages/presentation/production/cutting/CuttingListPage'),
);
const CuttingViewPage = lazy(
	() => import('../pages/presentation/production/cutting/CuttingViewPage'),
);
const BundlingListPage = lazy(
	() => import('../pages/presentation/production/bundling/BundlingListPage'),
);
const BundlingViewPage = lazy(
	() => import('../pages/presentation/production/bundling/BundlingViewPage'),
);
const BundleStockListPage = lazy(
	() => import('../pages/presentation/production/bundling/BundleStockListPage'),
);
const ProcessIssueListPage = lazy(
	() => import('../pages/presentation/production/processIssue/ProcessIssueListPage'),
);
const ProcessIssueViewPage = lazy(
	() => import('../pages/presentation/production/processIssue/ProcessIssueViewPage'),
);
const ProcessFlowListPage = lazy(
	() => import('../pages/presentation/production/processFlow/ProcessFlowListPage'),
);
const ReadyStockListPage = lazy(
	() => import('../pages/presentation/production/readyStock/ReadyStockListPage'),
);
const LabourHisaabListPage = lazy(
	() => import('../pages/presentation/production/labourHisaab/LabourHisaabListPage'),
);
const LabourHisaabViewPage = lazy(
	() => import('../pages/presentation/production/labourHisaab/LabourHisaabViewPage'),
);
const DeliveryChallanListPage = lazy(
	() => import('../pages/presentation/production/deliveryChallan/DeliveryChallanListPage'),
);
const ExpenseCategoryListPage = lazy(
	() => import('../pages/presentation/master/expenseCategory/ExpenseCategoryListPage'),
);
const TaxRateListPage = lazy(() => import('../pages/presentation/master/taxRate/TaxRateListPage'));
// const SalesOrderListPage = lazy(
// 	() => import('../pages/presentation/sales/salesOrder/SalesOrderListPage'),
// );
const SalesInvoiceListPage = lazy(
	() => import('../pages/presentation/sales/salesInvoice/SalesInvoiceListPage'),
);
const SalesInvoiceViewPage = lazy(
	() => import('../pages/presentation/sales/salesInvoice/SalesInvoiceViewPage'),
);
const CustomerPaymentListPage = lazy(
	() => import('../pages/presentation/sales/customerPayment/CustomerPaymentListPage'),
);
const CreditNoteListPage = lazy(
	() => import('../pages/presentation/sales/creditNote/CreditNoteListPage'),
);
const CreditNoteCreatePage = lazy(
	() => import('../pages/presentation/sales/creditNote/CreditNoteCreatePage'),
);
// const PurchaseOrderListPage = lazy(
// 	() => import('../pages/presentation/purchase/purchaseOrder/PurchaseOrderListPage'),
// );
const PurchaseInvoiceListPage = lazy(
	() => import('../pages/presentation/purchase/purchaseInvoice/PurchaseInvoiceListPage'),
);
const PurchaseInvoiceViewPage = lazy(
	() => import('../pages/presentation/purchase/purchaseInvoice/PurchaseInvoiceViewPage'),
);
const SupplierPaymentListPage = lazy(
	() => import('../pages/presentation/purchase/supplierPayment/SupplierPaymentListPage'),
);
const DebitNoteListPage = lazy(
	() => import('../pages/presentation/purchase/debitNote/DebitNoteListPage'),
);
const DebitNoteCreatePage = lazy(
	() => import('../pages/presentation/purchase/debitNote/DebitNoteCreatePage'),
);
const ExpenseListPage = lazy(() => import('../pages/presentation/finance/expense/ExpenseListPage'));
const ExpenseViewPage = lazy(() => import('../pages/presentation/finance/expense/ExpenseViewPage'));
const PettyCashListPage = lazy(
	() => import('../pages/presentation/finance/pettyCash/PettyCashListPage'),
);
const BankListPage = lazy(() => import('../pages/presentation/finance/bank/BankListPage'));
const DeliveryChallanViewPage = lazy(
	() => import('../pages/presentation/production/deliveryChallan/DeliveryChallanViewPage'),
);
const ReportsHubPage = lazy(() => import('../pages/presentation/reports/ReportsHubPage'));
const ReportsDashboardPage = lazy(
	() => import('../pages/presentation/reports/ReportsDashboardPage'),
);
const ReportDetailPage = lazy(() => import('../pages/presentation/reports/ReportDetailPage'));
const Page404 = lazy(() => import('../pages/presentation/auth/Page404'));

const contents: RouteProps[] = [
	{
		path: PAGE_ROUTES.LOGIN,
		element: <Login />,
	},
	{
		path: PAGE_ROUTES.FORGOT_PASSWORD,
		element: <ForgotPassword />,
	},
	{
		path: PAGE_ROUTES.RESET_PASSWORD,
		element: <ResetPassword />,
	},
	{
		path: PAGE_ROUTES.PAGE_404,
		element: <Page404 />,
	},
	{
		path: PAGE_ROUTES.DASHBOARD,
		element: <DashboardPage />,
	},
	{
		path: PAGE_ROUTES.PROFILE,
		element: <ProfilePage />,
	},
	{
		path: PAGE_ROUTES.GENERAL_SETTING,
		element: <GeneralSettingsPage />,
	},
	{
		path: PAGE_ROUTES.COMPANY,
		element: <GeneralSettingsPage />,
	},
	{
		path: PAGE_ROUTES.INVOICE_NUMBERING,
		element: <GeneralSettingsPage />,
	},
	{
		path: PAGE_ROUTES.USERS,
		element: <UserListPage />,
	},
	{
		path: PAGE_ROUTES.USERS_ADD,
		element: <UserAddPage />,
	},
	{
		path: PAGE_ROUTES.USERS_VIEW,
		element: <UserViewPage />,
	},
	{
		path: PAGE_ROUTES.USERS_EDIT,
		element: <UserEditPage />,
	},
	{
		path: PAGE_ROUTES.LOGIN_HISTORY,
		element: <LoginHistoryPage />,
	},
	{
		path: PAGE_ROUTES.LOGIN_HISTORY_USER,
		element: <LoginHistoryPage />,
	},
	{
		path: PAGE_ROUTES.ROLES,
		element: <RoleListPage />,
	},
	{
		path: PAGE_ROUTES.ROLES_ADD,
		element: <RoleAddPage />,
	},
	{
		path: PAGE_ROUTES.ROLES_VIEW,
		element: <RoleViewPage />,
	},
	{
		path: PAGE_ROUTES.ROLES_EDIT,
		element: <RoleEditPage />,
	},
	{
		path: PAGE_ROUTES.ITEMS,
		element: <ItemListPage />,
	},
	{
		path: PAGE_ROUTES.ITEM_TYPES,
		element: <ItemTypeListPage />,
	},
	{
		path: PAGE_ROUTES.SIZES,
		element: <SizeListPage />,
	},
	{
		path: PAGE_ROUTES.COLOURS,
		element: <ColourListPage />,
	},
	{
		path: PAGE_ROUTES.PROCESSES,
		element: <ProcessListPage />,
	},
	{
		path: PAGE_ROUTES.FABRICS,
		element: <FabricListPage />,
	},
	{
		path: PAGE_ROUTES.FABRIC_TYPES,
		element: <FabricTypeListPage />,
	},
	{
		path: PAGE_ROUTES.FABRIC_STAGES,
		element: <FabricStageListPage />,
	},
	{
		path: PAGE_ROUTES.PARTIES,
		element: <PartyListPage />,
	},
	{
		path: PAGE_ROUTES.CUTTING_COMPONENTS,
		element: <CuttingComponentListPage />,
	},
	{
		path: PAGE_ROUTES.LABOURS,
		element: <LabourListPage />,
	},
	{
		path: PAGE_ROUTES.FABRIC_INWARDS,
		element: <FabricInwardListPage />,
	},
	{
		path: PAGE_ROUTES.FABRIC_INWARDS_VIEW,
		element: <FabricInwardViewPage />,
	},
	{
		path: PAGE_ROUTES.FABRIC_STOCK,
		element: <FabricStockListPage />,
	},
	{
		path: PAGE_ROUTES.CUTTING_STOCK,
		element: <CuttingStockListPage />,
	},
	{
		path: PAGE_ROUTES.CUTTING,
		element: <CuttingListPage />,
	},
	{
		path: PAGE_ROUTES.CUTTING_VIEW,
		element: <CuttingViewPage />,
	},
	{
		path: PAGE_ROUTES.BUNDLING,
		element: <BundlingListPage />,
	},
	{
		path: PAGE_ROUTES.BUNDLING_VIEW,
		element: <BundlingViewPage />,
	},
	{
		path: PAGE_ROUTES.BUNDLE_STOCK,
		element: <BundleStockListPage />,
	},
	{
		path: PAGE_ROUTES.PROCESS_ISSUE_VIEW,
		element: <ProcessIssueViewPage />,
	},
	{
		path: PAGE_ROUTES.PROCESS_ISSUE,
		element: <ProcessIssueListPage />,
	},
	{
		path: PAGE_ROUTES.PROCESS_FLOW,
		element: <ProcessFlowListPage />,
	},
	{
		path: PAGE_ROUTES.READY_STOCK,
		element: <ReadyStockListPage />,
	},
	{
		path: PAGE_ROUTES.LABOUR_HISAAB_VIEW,
		element: <LabourHisaabViewPage />,
	},
	{
		path: PAGE_ROUTES.LABOUR_HISAAB_MONTHLY_SALARY,
		element: <LabourHisaabListPage />,
	},
	{
		path: PAGE_ROUTES.LABOUR_HISAAB,
		element: <LabourHisaabListPage />,
	},
	{
		path: PAGE_ROUTES.DELIVERY_CHALLAN_VIEW,
		element: <DeliveryChallanViewPage />,
	},
	{
		path: PAGE_ROUTES.DELIVERY_CHALLAN,
		element: <DeliveryChallanListPage />,
	},
	{
		path: PAGE_ROUTES.EXPENSE_CATEGORIES,
		element: <ExpenseCategoryListPage />,
	},
	{
		path: PAGE_ROUTES.TAX_RATES,
		element: <TaxRateListPage />,
	},
	// {
	// 	path: PAGE_ROUTES.SALES_ORDER,
	// 	element: <SalesOrderListPage />,
	// },
	{
		path: PAGE_ROUTES.SALES_INVOICE_VIEW,
		element: <SalesInvoiceViewPage />,
	},
	{
		path: PAGE_ROUTES.SALES_INVOICE,
		element: <SalesInvoiceListPage />,
	},
	{
		path: PAGE_ROUTES.CUSTOMER_PAYMENT,
		element: <CustomerPaymentListPage />,
	},
	{
		path: PAGE_ROUTES.CREDIT_NOTE_ADD,
		element: <CreditNoteCreatePage />,
	},
	{
		path: PAGE_ROUTES.CREDIT_NOTE_EDIT,
		element: <CreditNoteCreatePage />,
	},
	{
		path: PAGE_ROUTES.CREDIT_NOTE,
		element: <CreditNoteListPage />,
	},
	// {
	// 	path: PAGE_ROUTES.PURCHASE_ORDER,
	// 	element: <PurchaseOrderListPage />,
	// },
	{
		path: PAGE_ROUTES.PURCHASE_INVOICE_VIEW,
		element: <PurchaseInvoiceViewPage />,
	},
	{
		path: PAGE_ROUTES.PURCHASE_INVOICE,
		element: <PurchaseInvoiceListPage />,
	},
	{
		path: PAGE_ROUTES.SUPPLIER_PAYMENT,
		element: <SupplierPaymentListPage />,
	},
	{
		path: PAGE_ROUTES.DEBIT_NOTE_ADD,
		element: <DebitNoteCreatePage />,
	},
	{
		path: PAGE_ROUTES.DEBIT_NOTE_EDIT,
		element: <DebitNoteCreatePage />,
	},
	{
		path: PAGE_ROUTES.DEBIT_NOTE,
		element: <DebitNoteListPage />,
	},
	{
		path: PAGE_ROUTES.EXPENSES,
		element: <ExpenseListPage />,
	},
	{
		path: PAGE_ROUTES.EXPENSE_VIEW,
		element: <ExpenseViewPage />,
	},
	{
		path: PAGE_ROUTES.PETTY_CASH,
		element: <PettyCashListPage />,
	},
	{
		path: PAGE_ROUTES.BANK,
		element: <BankListPage />,
	},
	{
		path: PAGE_ROUTES.REPORTS_DASHBOARD,
		element: <ReportsDashboardPage />,
	},
	{
		path: PAGE_ROUTES.REPORT_LABOUR_PAYMENT_MONTHLY_SALARY,
		element: <ReportDetailPage />,
	},
	{
		path: PAGE_ROUTES.REPORT_DETAIL,
		element: <ReportDetailPage />,
	},
	{
		path: PAGE_ROUTES.REPORTS,
		element: <ReportsHubPage />,
	},
	{
		path: '*',
		element: <Page404 />,
	},
];

export default contents;
